// Shared Types for Claim State Reducers
// Re-exports types from main types file and defines utility functions

export type {
  ClaimState,
  ClaimAction,
  ClaimPhase,
  FlightSegment,
  EditableSegment,
  Passenger,
  IncidentType,
  Expense,
  UploadedDocument,
  ExtractedBookingData,
} from '../types';

// ============================================================================
// Utility Functions
// ============================================================================

export function generateId(): string {
  return `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

export function toEditableSegments(segments: FlightSegment[]): EditableSegment[] {
  return segments.map((seg) => ({
    ...seg,
    _id: generateId(),
    _original: { ...seg },
    _isNew: false,
  }));
}

export function toPassengers(
  passengers: Array<{ first_name: string; last_name: string }>
): Passenger[] {
  return passengers.map((p) => ({
    _id: generateId(),
    first_name: p.first_name,
    last_name: p.last_name,
    _isNew: false,
  }));
}

export function createNewSegment(): EditableSegment {
  const today = new Date().toLocaleDateString('de-DE');
  return {
    _id: generateId(),
    _isNew: true,
    carrier: '',
    flight_no: '',
    dep_iata: '',
    arr_iata: '',
    dep_date: today,
    dep_time: '',
    arr_time: '',
    booking_class_category: 'Economy',
  };
}

export function createNewPassenger(): Passenger {
  return {
    _id: generateId(),
    first_name: '',
    last_name: '',
    _isNew: true,
  };
}

export function createNewExpense(): Expense {
  return {
    id: generateId(),
    expense_type: 'other',
    amount_cents: 0,
    currency: 'EUR',
    description: '',
    _isNew: true,
  };
}

// Re-export for convenience
import type { FlightSegment, EditableSegment, Passenger, Expense } from '../types';
